import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

export default function ColumnGroupingTable({ shipmentsData }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
             <TableCell className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>Country</TableCell>
             <TableCell colSpan={2} align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>7 Days</TableCell>
             <TableCell colSpan={2} align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>14 Days</TableCell>
             <TableCell colSpan={2} align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>30 Days</TableCell>
             <TableCell colSpan={2} align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>90 Days</TableCell>
           </TableRow>
           <TableRow>
             <TableCell className="border-r-2 border-gray-300"></TableCell>
             <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>Amount</TableCell>
             <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>Shipments</TableCell>
             <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>Amount</TableCell>
             <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>Shipments</TableCell>
             <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>Amount</TableCell>
             <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>Shipments</TableCell>
             <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>Amount</TableCell>
             <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontWeight: 600 }}>Shipments</TableCell>
           </TableRow>

          </TableHead>
          <TableBody>
          {shipmentsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
            <TableRow key={row.receiverCountry} className={index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}>
              <TableCell component="th" scope="row" className="border-r-2 border-gray-300 p-1" sx={{ fontSize: "14px" }}>
                {row.receiverCountry}
              </TableCell>
              <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontSize: "12px" }}>
                {`$ ${row.data["7 days"].totalCustomerPrice.toFixed(2)}`}
              </TableCell>
              <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontSize: "13px", width: "10px" }}>{row.data["7 days"].shipmentCount}</TableCell>
              <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontSize: "12px" }}>
                {`$ ${row.data["14 days"].totalCustomerPrice.toFixed(2)}`}
              </TableCell>
              <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontSize: "13px", width: "10px" }}>{row.data["14 days"].shipmentCount}</TableCell>
              <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontSize: "12px" }}>
                {`$ ${row.data["30 days"].totalCustomerPrice.toFixed(2)}`}
              </TableCell>
              <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontSize: "13px", width: "10px" }}>{row.data["30 days"].shipmentCount}</TableCell>
              <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontSize: "12px" }}>
                {`$ ${row.data["90 days"].totalCustomerPrice.toFixed(2)}`}
              </TableCell>
              <TableCell align="center" className="border-r-2 border-gray-300" sx={{ fontSize: "13px" }}>{row.data["90 days"].shipmentCount}</TableCell>
            </TableRow>
          ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 25, 50]}
        component="div"
        count={shipmentsData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
